import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class ReviewRating extends Component
{
    constructor(props) {
        super(props);
        
        this.state = {

        };
    }
    
    render()
    {
        const { star_rating, count, dark_mode, label, size = "" } = this.props;

        let className = "d-flex align-items-center mb-1 " + size;

        if(!star_rating > 0)
            className += " invisible";
        
        
        return (
            <div 
                className={className}
                style={{ width: 'fit-content' }}
            >
                {
                    star_rating > 0 ?
                    <div>
                        {
                            _.times(5, (key) => {

                                return(
                                    <span key={key} className={(star_rating >= key + 1 ? "fa" : "far") + " fa-lg fa-star primary-text mr-1"}></span>
                                )
                            })
                        }
                    </div> :
                    <div>
                        {
                            _.times(5, (key) => {

                                return (
                                    <span key={key} className={"primary-text far" + '' + " fa-lg fa-star mr-1"}></span>
                                )
                            })
                        }
                    </div>
                }

                {label &&
                    <div>
                        <span 
                            className={dark_mode == true ? "font-italic font-small white-text ml-2" : "font-italic font-small text-muted ml-2"}>
                            ({count} reviews)
                        </span>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/ReviewRating.js